/**
 * Client ID Management
 * Generates and manages unique client IDs for each browser tab
 * Format: web_{timestamp}_{random}
 */

const CLIENT_ID_KEY = 'kido_chat_client_id'

function generateClientId(): string {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 9)
  return `web_${timestamp}_${random}`
}

export function getClientId(): string {
  if (typeof window === 'undefined') {
    return generateClientId()
  }

  try {
    let clientId = sessionStorage.getItem(CLIENT_ID_KEY)
    
    if (!clientId) {
      clientId = generateClientId()
      sessionStorage.setItem(CLIENT_ID_KEY, clientId)
    }
    
    return clientId
  } catch (error) {
    console.warn('Failed to access sessionStorage, using generated clientId:', error)
    return generateClientId()
  }
}

export function clearClientId(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    sessionStorage.removeItem(CLIENT_ID_KEY)
  } catch (error) {
    console.warn('Failed to clear clientId from sessionStorage:', error)
  }
}

export function hasClientId(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return sessionStorage.getItem(CLIENT_ID_KEY) !== null
  } catch {
    return false
  }
}

